module.exports = __webpack_public_path__ + "static/media/newskyline-product-2.975cb003.jpg";